import { useCallback, useEffect, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'src/AppContext';
import Button from 'src/components/Button';
import { useCheckbox } from 'src/components/Checkbox';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useTerms } from 'src/TermsContext';

export default function AccountAgree({ isShow }: AccountProcessProps): JSX.Element {
  const { t } = useTranslation();
  const { setIsTermShow, setIsPrivacyShow } = useTerms();
  const dispatch = useAppDispatch();
  const history = useCustomHistory();
  const termsCheckbox = useCheckbox({
    name: 'termsAllowed',
    component: (
      <label className="N_14_R text-greyish-brown">
        {t('account/agree/terms_title')}
        <span className="text-bluey-purple">({t('account/agree/agree_required')})</span>
      </label>
    ),
  });
  const privacyCheckbox = useCheckbox({
    name: 'privacyPolicyAllowed',
    component: (
      <label className="N_14_R text-greyish-brown">
        {t('account/agree/privacy_policy_title')}
        <span className="text-bluey-purple">({t('account/agree/agree_required')})</span>
      </label>
    ),
  });
  const allCheckbox = useCheckbox({
    name: 'allAllowed',
    component: <label className="N_14_R text-black font-medium">{t('account/agree/all_agree')}</label>,
  });

  useEffect(() => {
    termsCheckbox.setChecked(allCheckbox.checked);
    privacyCheckbox.setChecked(allCheckbox.checked);
  }, [allCheckbox.checked]);

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'back' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'hidden' });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  useEffect(() => {
    allCheckbox.setChecked(termsCheckbox.checked && privacyCheckbox.checked);
  }, [termsCheckbox.checked, privacyCheckbox.checked]);
  return (
    <div className={isShow ? '' : 'hidden'}>
      <div className="container mt-6">
        <h1 className="N_20_R">{t('account/agree/title')}</h1>
        <div className="mt-4 N_14_R text-brown-grey">{t('account/agree/subtitle')}</div>
        <div className="mt-6 h-1.5 w-full bg-light-gray-1"></div>
        <div className="mt-6 rounded-sm rounded-b-none border border-light-gray-2 px-4 py-6">
          <div className="flex justify-between items-center">
            {termsCheckbox.CustomCheckbox}
            <a
              href="#"
              className="N_12_M text-black underline cursor-pointer pl-3 whitespace-nowrap self-start"
              onClick={useCallback(
                (e) => {
                  e.preventDefault();
                  setIsTermShow(true);
                },
                [setIsTermShow],
              )}
            >
              {t('account/agree/read_whole_lecture')}
            </a>
          </div>
          <div className="mt-4 flex justify-between items-center">
            {privacyCheckbox.CustomCheckbox}
            <a
              href="#"
              className="N_12_M text-black underline cursor-pointer pl-3 whitespace-nowrap self-start"
              onClick={useCallback(
                (e) => {
                  e.preventDefault();
                  setIsPrivacyShow(true);
                },
                [setIsPrivacyShow],
              )}
            >
              {t('account/agree/read_whole_lecture')}
            </a>
          </div>
        </div>
        <div className="rounded-sm rounded-t-none border-l border-r border-b border-light-gray-2 px-4 py-4 flex">
          {allCheckbox.CustomCheckbox}
        </div>
        <div className="mt-6">
          <Button
            title={t('account/age/next_button')}
            disabled={!allCheckbox.checked}
            onClick={() => history.push('/account/form')}
          ></Button>
        </div>
      </div>
      <ul className="container mt-10 py-6 N_12_R text-brown-grey bg-pale-grey list-disc">
        <li>{t('account/agree/disclaimer_1')}</li>
      </ul>
    </div>
  );
}
